import { LockOpenIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedVoiceAgentRunUnblockedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface VoiceAgentRunUnblockedEventProps {
  event: DiscriminatedVoiceAgentRunUnblockedEvent;
}

export const VoiceAgentRunUnblockedEvent: React.FC<
  VoiceAgentRunUnblockedEventProps
> = ({ event }) => {
  const { task } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100">
          <LockOpenIcon className="h-4 w-4 text-green-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {task?.name && <ActivityTitle>{task.name}</ActivityTitle>}
      <ActivityDescription>
        {event.payload.previous_status && event.payload.new_status && (
          <div className="text-xs text-gray-500">
            {event.payload.previous_status} → {event.payload.new_status}
          </div>
        )}
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Voice AI Unblocked"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
